import type { ColumnPlugin, ColumnPluginContext } from "app/pages/sales-intelligence/common-components/column-picker";
import { UpgradeColumnButton } from "app/pages/sales-intelligence/common-components/column-picker/components/UpgradeColumnButton";

import AppsFeatureUpgradeBanner from "../../components/feature-hook/AppsFeatureUpgradeBanner/AppsFeatureUpgradeBanner";

import type { AppsColumnPickerPlugins, AppsUpgradePluginConfig } from "./types";

const APPS_UPGRADE_PLUGIN = "appsUpgrade" as const;

export const appsColumnPickerPlugins: AppsColumnPickerPlugins = {
    createUpgradeButton: (config: AppsUpgradePluginConfig): ColumnPlugin => ({
        id: APPS_UPGRADE_PLUGIN,
        slot: "column-action",
        behavior: "substitute",
        shouldRender: (context: ColumnPluginContext) =>
            context.column.upgradePlugin === APPS_UPGRADE_PLUGIN,
        render: () => ({
            priority: 1,
            component: (
                <UpgradeColumnButton
                    tooltipContent={
                        <AppsFeatureUpgradeBanner
                            isSubmitSuccess={config.isHookSubmitted}
                            onSubmit={config.onHookSubmit}
                        />
                    }
                />
            ),
        }),
    }),
};
